/* eslint-disable @typescript-eslint/no-var-requires */
import { applyMiddleware, Middleware, StoreEnhancer } from 'redux';

/**
 * Adds dev tools to redux thunk middleware if needed
 * @param middlewares the redux middlewares
 * @returns
 */
export const bindDevToolsIfNeeded = (middlewares: Middleware[]): StoreEnhancer => {
  if (process.env.NODE_ENV !== 'production') {
    const { composeWithDevTools } = require('redux-devtools-extension');

    return composeWithDevTools(applyMiddleware(...middlewares));
  }

  return applyMiddleware(...middlewares);
};
